import { gql } from "apollo-angular";

export const GET_TEST_OBJECTS_QUERY = gql`query configuratorTestObjects {
    configuratorTestObjects {
        Uid
        Name
    }
  }
  `
  